/**
 * Componentes visuais compartilhados pelas páginas do módulo The Acting.
 *
 * O que também é usado por outros módulos mora em `../lifeshub-common`.
 */
import { styled } from '@mui/material/styles'

import TablePagination from '@mui/material/TablePagination'
import { DataGrid } from '@mui/x-data-grid'

import { dataGridRowHoverSx, dataGridSx } from '../lifeshub-tokens'
import { skeletonPulse } from '../lifeshub-common'

// O DataGrid (MIT) exibe no máximo 100 linhas por página
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 75, 100]

export const TaDataGrid = styled(DataGrid)({
    ...dataGridSx,
    ...dataGridRowHoverSx,
    zoom: 0.8,
    fontSize: 12,
    '& .MuiDataGrid-row': { cursor: 'pointer' },
    '& .MuiDataGrid-menu .MuiPaper-root': {
        borderRadius: 10,
        border: '1px solid var(--border)',
        boxShadow: 'var(--shadow-2)'
    }
})

export const TaPagination = styled(TablePagination)({
    flexShrink: 0,
    overflow: 'hidden',
    borderTop: '1px solid var(--border)',
    color: 'var(--muted)',
    '& .MuiTablePagination-toolbar': { minHeight: 44, paddingLeft: 0 },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        fontSize: 12,
        color: 'var(--muted)'
    },
    '& .MuiTablePagination-select': { fontSize: 12, color: 'var(--ink)', fontWeight: 650 },
    '& .MuiIconButton-root': { color: '#2d332f', borderRadius: 8 },
    '& .MuiIconButton-root:hover': { backgroundColor: '#edf1ee' },
    '& .MuiIconButton-root.Mui-disabled': { color: '#b9bfbb' }
}) as typeof TablePagination

export const TaSkeleton = styled('div')({
    flexGrow: 1,
    minHeight: 0,
    backgroundColor: '#eef1ef',
    borderRadius: 9,
    animation: `${skeletonPulse} 1.4s ease-in-out infinite`,
    pointerEvents: 'none'
})
